<template>
  <a-modal
    v-model:visible="visible"
    :title="modalTitle"
    :confirm-loading="confirmLoading"
    :mask-closable="false"
    :destroy-on-close="true"
    width="480px"
    ok-text="确认"
    cancel-text="取消"
    wrap-class-name="followup_complete_modal"
    @ok="handleConfirm"
    @cancel="handleCancel"
  >
    <a-form layout="vertical" class="followup_form" :model="form" ref="formRef">
      <a-form-item
        v-if="mode === 'complete'"
        name="reason"
        label="完成备注"
        :rules="[{ required: true, message: '请输入完成备注', trigger: 'change' }]"
        :label-col="{ style: 'margin-bottom: 8px; ' }"
      >
        <a-textarea
          v-model:value="form.reason"
          :maxlength="500"
          :show-count="true"
          :rows="4"
          placeholder="请输入完成备注"
        />
      </a-form-item>

      <a-form-item
        name="nextFollowupAt"
        :label="mode === 'nextTime' ? '补充下次回访时间' : '下次回访时间'"
        :rules="[
          { required: mode === 'nextTime', message: '请选择下次回访时间', trigger: 'change' }
        ]"
        :label-col="{ style: 'margin-bottom: 8px; ' }"
      >
        <a-date-picker
          v-model:value="form.nextFollowupAt"
          format="YYYY-MM-DD"
          value-format="YYYY-MM-DD"
          :disabled-date="disabledDate"
          style="width: 100%"
          placeholder="请选择下次回访时间"
          allow-clear
          :showToday="false"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
export default { name: 'FollowupCompleteModal' }
</script>

<script setup>
import { ref, reactive, computed, defineEmits, defineExpose, h } from 'vue'
import { message as Message, Modal } from 'ant-design-vue'
import dayjs from 'dayjs'
import {
  completeActiveFollowup,
  fillNextFollowupTime,
  getCompleteFollowupForm
} from '@/api/UserPool/activeRevisit'

const emit = defineEmits(['success'])

const visible = ref(false)
const confirmLoading = ref(false)
// complete-完成回访 nextTime-补充下次回访时间
const mode = ref('complete')
const record = ref(null)

const form = reactive({
  reason: '',
  nextFollowupAt: null
})
const formRef = ref(null)
const modalTitle = computed(() => (mode.value === 'complete' ? '完成回访' : null))

// 仅允许选择未来的日期,不能选择当天的
function disabledDate(current) {
  return current && (current.isBefore(dayjs().startOf('day')) || current.isSame(dayjs(), 'day'))
}

function resetForm() {
  form.reason = ''
  form.nextFollowupAt = null
}

function openModal(type, row) {
  mode.value = type
  record.value = row
  resetForm()
  visible.value = true
  if (type === 'complete') {
    // 调用一个新的接口获取表单数据
    getCompleteFollowupForm({ followupId: record.value?.id })
      .then(res => {
        if (res) {
          form.reason = res.remark || ''
        }
      })
      .catch(error => {
        form.reason = ''
      })
  }
}

// 完成回访
function initComplete(row) {
  openModal('complete', row)
}

// 补充下次回访时间
function initNextTime(row) {
  openModal('nextTime', row)
}

async function handleConfirm() {
  formRef.value
    .validate()
    .then(async () => {
      const payload = {
        followupId: record.value?.id,
        nextFollowupAt: form.nextFollowupAt ? `${form.nextFollowupAt} 00:00:00` : null
      }
      if (mode.value === 'complete') {
        payload.reason = (form.reason || '').trim()
      }

      confirmLoading.value = true
      try {
        const requestFn = mode.value === 'complete' ? completeActiveFollowup : fillNextFollowupTime
        const msg = await requestFn(payload)
        if (msg) {
          Modal.info({
            title: () => '提示',
            content: () => h('div', `${msg}`),
            onOk() {
              visible.value = false
            }
          })
        } else {
          Message.success(mode.value === 'complete' ? '完成回访成功' : '补充成功')
          visible.value = false
        }
        emit('success')
      } catch (error) {
        // 错误提示已由 request 拦截器统一处理
        console.error('主动回访操作失败', error)
      } finally {
        confirmLoading.value = false
      }
    })
    .catch(error => {
      console.log('error', error)
    })
}

function handleCancel() {
  visible.value = false
}

defineExpose({ initComplete, initNextTime })
</script>

<style lang="scss">
.followup_complete_modal {
  .ant-modal-header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.09);
    padding: 16px 24px;
    margin-bottom: 0;
  }
  .ant-modal-title {
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.85);
  }
}
</style>
